<script setup lang="ts">
import { link } from "~/lib/utils/contents";
import { processError } from "~/lib/utils/errors";

const omniaSdk = useOmniaSdk();
const route = useRoute();
const hubId = useParamId("hub_id");
const contentId = useParamId();

watch(
  () => route.query,
  () => refresh()
);

const { data: hub, error: hubError } = await useAsyncData(`hub-${hubId}`, async () => {
  try {
    return await omniaSdk.v1.hubs.get(hubId);
  } catch (error) {
    processError(error);
  }
});

if (hubError.value) processError(hubError.value);

const { data, status, error, refresh } = await useAsyncData(`content-${contentId}`, async () => {
  try {
    return await omniaSdk.v1.contents.get(contentId, route.query.date ? { date: route.query.date.toString() } : {});
  } catch (error) {
    processError(error);
  }
});

if (error.value) processError(error.value);

const { data: hubData } = useAsyncData(`hub-${hubId}-all`, async () => {
  try {
    return await omniaSdk.v1.contents.all({ hub: hubId });
  } catch (error) {
    processError(error);
  }
});
</script>

<template>
  <FrontBreadcrumHero :breadcrumbs="[{ href: link({ hub }), title: hub?.title }, { title: data?.title }]" :search="false"></FrontBreadcrumHero>

  <Skeleton v-if="status === 'pending'" class="main-content w-full h-52 rounded-lg mb-10" />
  <FrontContentView :link-config="{ hub }" v-model:content="data" v-else-if="data" />

  <div class="py-16 bg-primary-50 print:hidden">
    <div class="main-content">
      <h2 class="text-3xl font-extrabold mb-3">Ti potrebbe interessare anche</h2>
      <FrontContentsOverview v-if="hubData" v-model="hubData" :link-config="{ hub }" :read-all-to="(frontType) => link({ hub, frontType })" :transparent="true"></FrontContentsOverview>
    </div>
  </div>
</template>
